import { useEffect, useState } from 'react';
import {
  fetchPaymentGatewaySettings,
  getEnabledOnlineProviders,
  resolveMaxAmountToman,
} from '../services/paymentGateway';
import { MAX_ONLINE_TRANSACTION_TOMAN } from '../themeSetting';

/**
 * Loads public payment gateway settings for shopui.
 */
export function usePaymentGatewaySettings() {
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchPaymentGatewaySettings()
      .then((data) => {
        if (!cancelled) setSettings(data);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const onlineEnabled = Boolean(settings?.enabled) && getEnabledOnlineProviders(settings).length > 0;
  const transferEnabled = Boolean(settings?.transfer_receipt?.enabled);
  const depositEnabled = settings?.deposit?.enabled !== false;
  const enabledProviders = getEnabledOnlineProviders(settings);
  const defaultProvider =
    enabledProviders.find((p) => p.key === settings?.default_provider)?.key ||
    enabledProviders[0]?.key ||
    'sep';

  return {
    loading,
    settings,
    onlineEnabled,
    transferEnabled,
    depositEnabled,
    enabledProviders,
    defaultProvider,
    transferReceipt: settings?.transfer_receipt || { enabled: false },
    deposit: settings?.deposit || { enabled: true },
    maxAmountToman: settings ? resolveMaxAmountToman(settings) : MAX_ONLINE_TRANSACTION_TOMAN,
  };
}
